const getElevRouteFromPage = function(page) {
	if (page.name === "office.schools") {
		return {file: "schools/index.html"};
	}
	if (page.name === "office.apparel") {
		return {file: "apparel/shirt-beast/index.html"};
	}
	if (page.name === "office.book") {
		// bookHash 3A is the math-3A book, bookhash 3AS is the science-3A book.
		return {file: "books/" + page.bookHash + ".html"};
	}
	if (page.name === "office.bookScience") {
		return {file: "books/science/" + page.bookHash + ".html"};
	}
	if (page.name === "office.bookLevelScience") {
		const level = parseInt(page.bookHash.split("-")[1], 10);
		// Since we only have Level 3 science, but all the other levels of math, we need to handle this differently.
		// We will filter out the science levels to only those supported.
		const supportedScienceLevels = [3, 4];
		if (supportedScienceLevels.includes(level)) {
			return {
				file: `books/science/level-${level}.html`,
				fallbackFile: "books/index.html",
				level,
			};
		}
		return {
			file: `books/index.html`,
			level,
		};
	}
	if (page.name === "office.bookLevel") {
		return {
			file: "books/level-" + page.level + ".html",
			fallbackFile: "books/index.html",
		};
	}
	if (page.name === "office.bookstore") {
		return {file: "books/index.html"};
	}
	if (page.name === "office.allbooks") {
		return {file: "books/all.html"};
	}
	if (page.name === "office.savewithfriends") {
		return {file: "saveWithFriends.html"};
	}
	if (page.name === "office.gifting") {
		return {file: "gifting.html"};
	}
	if (page.name === "office.faq") {
		return {file: "faq/" + page.section + ".html"};
	}
	if (page.name === "office.educators") {
		return {file: "educators/index.html"};
	}
	if (page.name === "office.outcomes") {
		return {file: "educators/outcomes/index.html"};
	}
	if (page.name === "office.playground") {
		if (page.activityName) {
			return {file: "playground/" + page.activityName + ".html"};
		}
		return {file: "playground/index.html"};
	}
	if (page.name === "allten.play") {
		return {file: "allten/index.html"};
	}
	if (page.name === "office.resources" && page.section !== "errata") {
		return {file: "resources/" + page.section + ".html"};
	}
	if (page.name === "playingcards.main") {
		return {file: "playingcards/index.html"};
	}
	if (page.name === "playingcards.answers") {
		return {file: "playingcards/answers/index.html"};
	}
	if (page.name === "playingcards.redirect") {
		return {file: "cards/index.html"};
	}
	if (page.name === "office.baonline") {
		return {file: "online/index.html"};
	}
	if (page.name === "office.main" && page.openLoginModal) {
		return {file: "signin/index.html"};
	}
	if (page.name === "office.enroll") {
		return {file: "online/enroll/index.html"};
	}
	if (page.name === "office.main") {
		return {file: "home/index.html"};
	}
	if (page.name === "office.contact") {
		return {file: "contact/index.html"};
	}
	if (page.name === "office.about") {
		return {file: "about/index.html"};
	}
	if (page.name === "office.liveClasses") {
		return {file: "live-classes/index.html"};
	}
	if (page.name === "office.cards") {
		return {file: "cards/index.html"};
	}
	return null;
};

/** Page names whose HTML is not the trainer SPA and not an elev view (dedicated server routes, etc.). */
const SEPARATE_DOCUMENT_SHELL_PAGE_NAMES = new Set(["puzzles.daily"]);

/**
 * True when in-app navigation must use a full document load (window.location), not history.push.
 * Includes all elev static pages plus any {@link SEPARATE_DOCUMENT_SHELL_PAGE_NAMES} shell.
 */
const requiresFullDocumentNavigation = function(page) {
	if (!page || !page.name) return false;
	if (getElevRouteFromPage(page)) return true;
	return SEPARATE_DOCUMENT_SHELL_PAGE_NAMES.has(page.name);
};

module.exports = {
	getElevRouteFromPage,
	requiresFullDocumentNavigation,
};
